module.exports = __webpack_public_path__ + "static/story3-01-533x800-5cef7581cd0f9063b9a0db2d4b517145.jpg";